import type { Provenance } from '@losan/core';

export function DemoBadge({ provenance, label = 'Demo' }: { provenance: Provenance; label?: string }) {
  if (provenance === 'real') return null;
  return <span className="demo-badge" title="Datos de demostración (fuente aún no conectada)">{label}</span>;
}
